import { ServiceRequestStatus } from "@coherehealth/qm-api";

export const isTerminalStatus = (authStatus: string) =>
  ["DENIED", "APPROVED", "PARTIALLY_APPROVED", "WITHDRAWN"].includes(authStatus);

export const getMostRecentSRWithNonTerminalStatus = (
  serviceRequests: ServiceRequestStatus[] | undefined
): ServiceRequestStatus | undefined => {
  const sortedWithDateCreatedSRs = serviceRequests?.sort(
    (a, b) => (b.dateCreated ? Date.parse(b.dateCreated) : 0) - (a.dateCreated ? Date.parse(a.dateCreated) : 0)
  );
  return sortedWithDateCreatedSRs?.find((sr) => sr.status && !isTerminalStatus(sr.status));
};
